import { useState } from "react";

export default function Login({ setUser, setPage }) {
  const [email, setEmail] = useState("");

  const handleLogin = () => {
    if (email) {
      setUser(email);
      setPage("dashboard");
    } else {
      alert("กรุณากรอกชื่อผู้ใช้งาน");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-400 via-red-400 to-red-600 p-6">
      <h1 className="text-3xl font-bold text-white mb-8">สมัครสมาชิก/เข้าสู่ระบบ</h1>
      <input
        type="email"
        placeholder="ชื่อผู้ใช้ของคุณ"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="p-3 rounded-xl mb-4 w-72 text-gray-700"
      />
      <button
        onClick={handleLogin}
        className="bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-2xl w-72 font-semibold transition"
      >
        เข้าสู่ระบบ / สมัคร
      </button>
    </div>
  );
}
